var app = angular.module("leonardo");

var DynamicFormStates = function($stateProvider) {
  $stateProvider.state('documents.dynamic-forms', {
    url: "/dynamic-forms",
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DynamicFormListFilters',
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/dynamic-form-list.html',
        controller: 'DynamicFormListActions',
      },
      'breadcrumb@authenticated.layout-main': {
        templateUrl: 'views/templates/dynamic-forms/breadcrumb.html',
        controller: 'DynamicFormBreadCrumb'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/dynamic-forms/list.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic forms',
    }
  });

  $stateProvider.state('documents.dynamic-forms-folder', {
    url: "/dynamic-forms-folders/:pk",
    params: {
      pk: '',
      squash: false
    },
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DynamicFormListFilters',
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/dynamic-form-list.html',
        controller: 'DynamicFormListActions'
      },
      'breadcrumb@authenticated.layout-main': {
        templateUrl: 'views/templates/dynamic-forms/breadcrumb.html',
        controller: 'DynamicFormBreadCrumb'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/dynamic-forms/list.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic forms'
    }
  });

  $stateProvider.state('documents.dynamic-forms.edit', {
    url: "/:pk/edit?folder",
    params: {
      pk: '',
      squash: false
    },
    cssClass: 'page-dynamic-form-edit',
    views: {
      'filters@authenticated.layout-main': {},
      'title@authenticated.layout-main': {
        template: '<h1>Dynamic Form Edit</h1>'
      },
      'content@authenticated.layout-main': {
        controller: 'DynamicFormReactController',
        templateUrl: 'views/templates/dynamic-forms/form.html',
      }
    },
    resolve: {
      formObj: ['DynamicFormRestService', '$stateParams', function(DynamicFormRestService, $stateParams) {
        return DynamicFormRestService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit'
    }
  });

  $stateProvider.state('documents.dynamic-forms.add', {
    url: "/add?folder",
    cssClass: 'page-dynamic-form-add',
    action: 'create',
    views: {
      'filters@authenticated.layout-main': {},
      'title@authenticated.layout-main': {
        template: '<h1>Add Dynamic Form</h1>'
      },
      'content@authenticated.layout-main': {
        controller: 'DynamicFormReactController',
        templateUrl: 'views/templates/dynamic-forms/form.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Create'
    },
    resolve: {
      formObj: ['DynamicFormRestService', function(DynamicFormRestService) {
        return DynamicFormRestService.bulkObject();
      }]
    }
  });

  $stateProvider.state('documents.dynamic-forms.account-tags', {
    url: "/account-tags",
    views: {
      'filters@authenticated.layout-main': {
        controller: 'TagsListFilter',
        templateUrl: 'views/templates/filter/filters-base.html'
      },
      'actions@authenticated.layout-main': {},
      'title@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TagsController',
        templateUrl: 'views/templates/dynamic-forms/tags.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Tags'
    },
  });

  $stateProvider.state('documents.dynamic-forms.system-tags', {
    url: "/system-tags",
    system: true,
    views: {
      'filters@authenticated.layout-main': {
        controller: 'TagsListFilter',
        templateUrl: 'views/templates/filter/filters-base.html'
      },
      'title@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {
        controller: 'DynamicFormListActions',
        templateUrl: 'views/templates/actions/dynamic-form-tags.html',
      },
      'content@authenticated.layout-main': {
        controller: 'TagsController',
        templateUrl: 'views/templates/dynamic-forms/tags.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Tags'
    },
  });

};

app.config(['$stateProvider', DynamicFormStates ]);
